<app-expert-filter
  class="experts-filter"
  [experts]="experts"
  [viewStage]="viewStage"
  (filterExperts)="filterExperts($event)"
>
</app-expert-filter>

<div class="expert-list" data-test-id="expert-list-expert-list">
  @if (expertsFiltered.length) {
    <app-expert-table
      data-test-id="expert-list-not-on-hold-experts"
      [experts]="expertsFiltered"
      [expertLoadingIds]="expertLoadingIds"
      [viewStage]="viewStage"
      [opportunity]="opportunity"
      [isExpertApprovalRequired]="isExpertApprovalRequired"
    >
    </app-expert-table>
  }

  @if (!expertsFiltered.length && !onHoldExperts.length) {
    <div class="empty-message">
      <div class="hex-container">
        <i class="material-icons">person_outline</i>
      </div>
      <h4>No experts</h4>
    </div>
  }

  @if (onHoldExperts.length) {
    <div class="on-hold" data-test-id="expert-list-on-hold-banner">
      <div class="badge flex justify-center items-center gap-2">
        <app-on-hold-svg></app-on-hold-svg>
        <span>On hold</span>
      </div>
    </div>
    <app-expert-table
      class="gray"
      data-test-id="expert-list-on-hold-experts"
      [experts]="onHoldExperts"
      [expertLoadingIds]="expertLoadingIds"
      [viewStage]="viewStage"
      [opportunity]="opportunity"
      [isExpertApprovalRequired]="isExpertApprovalRequired"
    >
    </app-expert-table>
  }
</div>
